<template lang="html">
    <div ref="calendarDomWrapper" class="default-calendar__body" ></div>
</template>

<script>
import VanillaCalendar from '@uvarov.frontend/vanilla-calendar';
import { onMounted, ref } from 'vue';
export default {
    name : 'RoscarCalendar',
    props : {
        modelValue : {
            type : String,
            default : '',
        },
    },
    setup (props, { emit }) {
        const calendarDomWrapper = ref(null);

		function getFormattedCurrentDate() {
			const currentDate = new Date();
			const year = currentDate.getFullYear();
			const month = String(currentDate.getMonth() + 1).padStart(2, '0');
			const day = String(currentDate.getDate()).padStart(2, '0');
			return  `${year}-${month}-${day}`
		}

        onMounted(() => {
            const calendar = new VanillaCalendar(calendarDomWrapper.value, {
                date: {
                    min: getFormattedCurrentDate()
                },
                actions: {
                    clickDay(e, dates) {
                        emit('update:modelValue', dates);
                    },
                },
                settings: {
                    lang: 'ru',
                },
            })
            calendar.init();
        });
        return {
            calendarDomWrapper,
        }
    }
}
</script>
